import { render, staticRenderFns } from "./NotificationBookingOverview.vue?vue&type=template&id=2dac2290&scoped=true"
import script from "./NotificationBookingOverview.vue?vue&type=script&lang=ts"
export * from "./NotificationBookingOverview.vue?vue&type=script&lang=ts"
import style0 from "./NotificationBookingOverview.vue?vue&type=style&index=0&id=2dac2290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac2290",
  null
  
)

export default component.exports